import { apiSahBudgets } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = `budgets-services`;

const config = [
  { actionType: 'getAll', apiPath: `${apiSahBudgets}/sections/items`, method: get },
  { actionType: 'getBudgetExternalServices', apiPath: `${apiSahBudgets}/sections/items/external`, method: get },
];

export const { getAll, getBudgetExternalServices } = createThunks(typePrefix, config);
